import { render } from "./DcViewDialog.vue?vue&type=template&id=71fabcd3&scoped=true"
import script from "./DcViewDialog.vue?vue&type=script&lang=js"
export * from "./DcViewDialog.vue?vue&type=script&lang=js"

import "./DcViewDialog.vue?vue&type=style&index=0&id=71fabcd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fabcd3"]])

export default __exports__